import usePageContext from '@rover/react-lib/src/context/usePageContext';
import {
  effects as frontendConfigurationEffects,
  selectors as frontendConfigurationSelectors,
} from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import type { ApiFrontendConfigurationRetrieve200 } from '@rover/rsdk/src/apiClient/latest/model/apiFrontendConfigurationRetrieve200';
import {
  IsFlagActive,
  SetLanguage,
  useFrontendConfiguration,
} from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

import useDucks from './useDucks';

type FrontendConfigurationSelectorProps = {
  data?: ApiFrontendConfigurationRetrieve200;
  isFlagActive: IsFlagActive;
  language?: string;
  settings?: ApiFrontendConfigurationRetrieve200['settings'];
  branchKey?: string;
  supportsMobileApp?: boolean;
};

type FrontendConfigurationEffectProps = {
  setLanguage: SetLanguage;
};

export type FrontendConfigurationData = FrontendConfigurationSelectorProps &
  FrontendConfigurationEffectProps;

const selector = (state): FrontendConfigurationSelectorProps => ({
  data: frontendConfigurationSelectors.getFrontendConfiguration(state),
  isFlagActive: frontendConfigurationSelectors.isFlagActive(state),
  language: frontendConfigurationSelectors.getLanguage(state),
  settings: frontendConfigurationSelectors.getSettings(state),
  branchKey: frontendConfigurationSelectors.getSettings(state)?.branchKey,
  supportsMobileApp: frontendConfigurationSelectors.getSettings(state)?.supportsMobileApp,
});

const effects = {
  setLanguage: frontendConfigurationEffects.setLanguage,
};

const useFrontendConfigurationShim = (): FrontendConfigurationData => {
  const { isReactQueryRoute } = usePageContext();
  const { data: selectedData } = useDucks({ selector, effects });
  const query = useFrontendConfiguration({ enabled: isReactQueryRoute });
  const results = isReactQueryRoute ? query : selectedData;
  return results;
};

export default useFrontendConfigurationShim;
